import { Chip } from "@mui/material";
import useSWR from "swr";

import { API_BASE } from "../config/api";
import {
  Customer,
  CustomerFilters,
  CustomerListResponse,
  UserStatus,
} from "../types/crm";
import { FetchOptions, SWRType } from "../types/global";
import { authFetcher } from "../utils/auth-fetch";

const BASE = API_BASE.CUSTOMER_ADMIN;

const USE_MOCK = import.meta.env.VITE_MOCK_AUTH === "true";

const mockCustomers: Customer[] = [
  {
    id: "cust-001",
    name: "Somchai",
    surname: "Jaidee",
    email: "somchai.j@email.com",
    phone: "081-234-5678",
    ecp_code: "ECP-TH-001",
    shop_name: "Vision Plus Bangkok",
    line_name: "somchai_line",
    status: "active",
    points: 1500,
    points_breakdown: {
      current_points: 1500,
      total_earned: 2000,
      total_redeemed: 500,
      expired_points: 0,
      valid_earned_points: 1500,
      expiring_points: [],
    },
    points_history: [],
    status_history: [],
    last_login: "2025-02-10T08:30:00Z",
    created_at: "2025-01-15T10:00:00Z",
    created_by: { id: "admin-1", name: "Admin" },
    updated_at: "2025-02-10T08:30:00Z",
    updated_by: { id: "admin-1", name: "Admin" },
  },
  {
    id: "cust-002",
    name: "Naree",
    surname: "Suksawat",
    email: "naree.s@email.com",
    phone: "089-876-5432",
    ecp_code: "ECP-TH-002",
    shop_name: "Clear Eye Chiang Mai",
    line_name: "naree_optical",
    status: "in_monitor",
    points: 800,
    points_breakdown: {
      current_points: 800,
      total_earned: 800,
      total_redeemed: 0,
      expired_points: 0,
      valid_earned_points: 800,
      expiring_points: [],
    },
    points_history: [],
    status_history: [],
    last_login: "2025-02-08T14:20:00Z",
    created_at: "2025-01-20T09:00:00Z",
    created_by: { id: "admin-1", name: "Admin" },
    updated_at: "2025-02-08T14:20:00Z",
    updated_by: { id: "admin-1", name: "Admin" },
  },
  {
    id: "cust-003",
    name: "Wichai",
    surname: "Tongkham",
    email: "wichai.t@email.com",
    phone: "062-111-2233",
    ecp_code: "ECP-TH-003",
    shop_name: "Optical House Phuket",
    line_name: "wichai_t",
    status: "active",
    points: 3200,
    points_breakdown: {
      current_points: 3200,
      total_earned: 4000,
      total_redeemed: 800,
      expired_points: 0,
      valid_earned_points: 3200,
      expiring_points: [],
    },
    points_history: [],
    status_history: [],
    last_login: "2025-02-12T11:45:00Z",
    created_at: "2024-11-05T13:00:00Z",
    created_by: { id: "admin-1", name: "Admin" },
    updated_at: "2025-02-12T11:45:00Z",
    updated_by: { id: "admin-1", name: "Admin" },
  },
  {
    id: "cust-004",
    name: "Pranee",
    surname: "Worawit",
    email: "pranee.w@email.com",
    phone: "095-444-5566",
    ecp_code: "ECP-TH-004",
    shop_name: "EyeCare Center Korat",
    line_name: "pranee_w",
    status: "rejected",
    points: 0,
    points_breakdown: {
      current_points: 0,
      total_earned: 0,
      total_redeemed: 0,
      expired_points: 0,
      valid_earned_points: 0,
      expiring_points: [],
    },
    points_history: [],
    status_history: [],
    last_login: "2025-01-30T16:00:00Z",
    created_at: "2025-01-25T08:30:00Z",
    created_by: { id: "admin-1", name: "Admin" },
    updated_at: "2025-01-30T16:00:00Z",
    updated_by: { id: "admin-1", name: "Admin" },
  },
  {
    id: "cust-005",
    name: "Arthit",
    surname: "Saetang",
    email: "arthit.s@email.com",
    phone: "083-999-8877",
    ecp_code: "ECP-TH-005",
    shop_name: "Lens Master Pattaya",
    line_name: "arthit_lens",
    status: "active",
    points: 2100,
    points_breakdown: {
      current_points: 2100,
      total_earned: 2500,
      total_redeemed: 400,
      expired_points: 0,
      valid_earned_points: 2100,
      expiring_points: [],
    },
    points_history: [],
    status_history: [],
    last_login: "2025-02-14T09:15:00Z",
    created_at: "2024-12-10T07:00:00Z",
    created_by: { id: "admin-1", name: "Admin" },
    updated_at: "2025-02-14T09:15:00Z",
    updated_by: { id: "admin-1", name: "Admin" },
  },
  {
    id: "cust-006",
    name: "Kanya",
    surname: "Rattana",
    email: "kanya.r@email.com",
    phone: "091-222-3344",
    ecp_code: "ECP-TH-006",
    shop_name: "Siam Optical Hat Yai",
    line_name: "kanya_r",
    status: "inactive",
    points: 450,
    points_breakdown: {
      current_points: 450,
      total_earned: 600,
      total_redeemed: 150,
      expired_points: 0,
      valid_earned_points: 450,
      expiring_points: [],
    },
    points_history: [],
    status_history: [],
    last_login: "2024-12-20T10:30:00Z",
    created_at: "2024-10-15T12:00:00Z",
    created_by: { id: "admin-1", name: "Admin" },
    updated_at: "2024-12-20T10:30:00Z",
    updated_by: { id: "admin-1", name: "Admin" },
  },
  {
    id: "cust-007",
    name: "Tawan",
    surname: "Pholsiri",
    email: "tawan.p@email.com",
    phone: "064-555-6677",
    ecp_code: "ECP-TH-007",
    shop_name: "BrightEye Khon Kaen",
    line_name: "tawan_bright",
    status: "active",
    points: 950,
    points_breakdown: {
      current_points: 950,
      total_earned: 1200,
      total_redeemed: 250,
      expired_points: 0,
      valid_earned_points: 950,
      expiring_points: [],
    },
    points_history: [],
    status_history: [],
    last_login: "2025-02-13T15:00:00Z",
    created_at: "2025-01-02T11:00:00Z",
    created_by: { id: "admin-1", name: "Admin" },
    updated_at: "2025-02-13T15:00:00Z",
    updated_by: { id: "admin-1", name: "Admin" },
  },
  {
    id: "cust-008",
    name: "Siriwan",
    surname: "Kamolchai",
    email: "siriwan.k@email.com",
    phone: "086-333-4455",
    ecp_code: "ECP-TH-008",
    shop_name: "Focus Lens Udon Thani",
    line_name: "siriwan_focus",
    status: "suspended",
    points: 0,
    points_breakdown: {
      current_points: 0,
      total_earned: 1000,
      total_redeemed: 1000,
      expired_points: 0,
      valid_earned_points: 0,
      expiring_points: [],
    },
    points_history: [],
    status_history: [],
    last_login: "2025-01-05T09:00:00Z",
    created_at: "2024-09-20T14:00:00Z",
    created_by: { id: "admin-1", name: "Admin" },
    updated_at: "2025-01-05T09:00:00Z",
    updated_by: { id: "admin-1", name: "Admin" },
  },
  {
    id: "cust-009",
    name: "Piyapong",
    surname: "Maneerat",
    email: "piyapong.m@email.com",
    phone: "097-777-8899",
    ecp_code: "ECP-TH-009",
    shop_name: "Diamond Eye Chonburi",
    line_name: "piyapong_diamond",
    status: "in_monitor",
    points: 300,
    points_breakdown: {
      current_points: 300,
      total_earned: 300,
      total_redeemed: 0,
      expired_points: 0,
      valid_earned_points: 300,
      expiring_points: [],
    },
    points_history: [],
    status_history: [],
    last_login: "2025-02-11T13:30:00Z",
    created_at: "2025-02-01T10:00:00Z",
    created_by: { id: "admin-1", name: "Admin" },
    updated_at: "2025-02-11T13:30:00Z",
    updated_by: { id: "admin-1", name: "Admin" },
  },
  {
    id: "cust-010",
    name: "Darunee",
    surname: "Chaiwong",
    email: "darunee.c@email.com",
    phone: "088-666-7788",
    ecp_code: "ECP-TH-010",
    shop_name: "Crystal Vision Rayong",
    line_name: "darunee_crystal",
    status: "active",
    points: 1750,
    points_breakdown: {
      current_points: 1750,
      total_earned: 2200,
      total_redeemed: 450,
      expired_points: 0,
      valid_earned_points: 1750,
      expiring_points: [],
    },
    points_history: [],
    status_history: [],
    last_login: "2025-02-15T07:45:00Z",
    created_at: "2024-11-28T09:30:00Z",
    created_by: { id: "admin-1", name: "Admin" },
    updated_at: "2025-02-15T07:45:00Z",
    updated_by: { id: "admin-1", name: "Admin" },
  },
];

const mockResponse: CustomerListResponse = {
  data: mockCustomers,
  total_records: mockCustomers.length,
  total_pages: 1,
};

const useCrmCustomers = (
  autoFetch = false,
  options: FetchOptions | null = null,
  filters: CustomerFilters = {},
) => {
  let swrUrl = `${BASE}/customers`;
  if (options?.fetchOne && options?.id) {
    swrUrl = `${BASE}/customers/${options.id}`;
  }

  const {
    data: apiData,
    isLoading: apiLoading,
    mutate,
    error,
  }: SWRType = useSWR(
    autoFetch && !USE_MOCK ? [swrUrl, filters] : null,
    ([url, queryParams]) => authFetcher("GET", url, null, queryParams),
    {
      onErrorRetry: (error) => {
        if (error.status === 404) return;
      },
    },
  );

  const data = USE_MOCK ? mockResponse : apiData;
  const dataLoading = USE_MOCK ? false : apiLoading;

  const getStatusChip = (status: UserStatus) => {
    switch (status) {
      case "active":
        return <Chip label="Active" color="success" size="small" />;
      case "inactive":
        return <Chip label="Pending Approval" color="warning" size="small" />;
      case "in_monitor":
        return <Chip label="In Monitor" color="warning" size="small" />;
      case "rejected":
        return <Chip label="Rejected" color="error" size="small" />;
      case "suspended":
        return <Chip label="Suspended" color="error" size="small" />;
      default:
        return <Chip label="Unknown" size="small" />;
    }
  };

  const getStatusOptions = () => [
    { label: "All Statuses", value: "" },
    { label: "Active", value: "active" },
    { label: "Pending Approval", value: "inactive" },
    { label: "In Monitor", value: "in_monitor" },
    { label: "Rejected", value: "rejected" },
    { label: "Suspended", value: "suspended" },
  ];

  return {
    data,
    dataLoading,
    mutate,
    error,
    getStatusChip,
    getStatusOptions,
  };
};

export default useCrmCustomers;
